import React from 'react';
import { Dropdown, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import eng from '../../assets/images/en.svg';
import vie from '../../assets/images/vi.svg';


export const changeLanguage = (i18n, language) => {
  localStorage.setItem('cft-language', language);
  i18n.changeLanguage(language);
};

const MultiLanguage = () => {
  // change language
  const multi = [
    { key: 'en', value: 'English' },
    { key: 'vi', value: 'Tiếng Việt' },
  ];
  const { i18n } = useTranslation();
  let lang = localStorage.getItem('cft-language');
  if (!lang) lang = 'vi';
  return (
    <Dropdown
      style={{
        margin: '0 auto',
        marginTop: '8px',
        marginRight: '30px',
        height: '100%',
      }}
    >
      <Dropdown.Toggle
        variant="none"
        className="border-0 p-0 btn tgle"
        id="dropdown-basic"
        style={{ lineHeight: '100%' }}
      >
        <div>
          {lang === 'vi' ? (
            <div className="d-flex items-center justify-between justify-content-center">
              <img className="mr-1" src={vie} alt="vie" height="15" />
              <span>VIE</span>
            </div>
          ) : (
            <div className="d-flex items-center justify-between justify-content-center">
              <img className="mr-1" src={eng} alt="eng" height="15" />
              <span>ENG</span>
            </div>
          )}
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="profile-notification" id="lang">
        {multi?.map((item, index) => (
          <ListGroup className="pro-body" key={index}>
            <Link to="#!">
              <ListGroup.Item onClick={() => changeLanguage(i18n, item.key)}>
                {item.value}
              </ListGroup.Item>
            </Link>
          </ListGroup>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MultiLanguage;
